
function Logo() {
    return(        
            <div className="logo">			
                <h1>PROJART</h1>
            </div>
        );
    
}
export default Logo;